module.exports = __webpack_public_path__ + "img/atl_new_logo.67af633f.png";